import React, { useContext, useEffect, useState } from 'react';

import { Select } from 'antd';

import { useLayoutContext } from '@contexts/LayoutContext';
import { useUserPermission } from '@contexts/UserContext';

import NwIcon from '@components/Gui/NwIcon';

import { HeaderContext } from '../Header/NwHeader';
import { StyledAreaSelect } from '../Header/NwHeaderUI';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { Option } = Select;

const AreaSelect = () => {
    const headerContextValues = useContext(HeaderContext);
    const { area, onChangeArea } = headerContextValues;
    const layoutContext = useLayoutContext();
    const { isMobile } = layoutContext;
    const [currentArea, setCurrentArea] = useState(area);

    useEffect(() => {
        setCurrentArea(area);
    }, [area]);

    const accessAccounting = useUserPermission('AccessAccounting');
    const accessBooking = useUserPermission('AccessBooking');
    const accessManagement = useUserPermission('AccessManagement');
    const accessScouting = useUserPermission('AccessScouting');
    const accessArt = useUserPermission('AccessArt');

    const onChangeCurrentArea = (value) => {
        setCurrentArea(value);
        onChangeArea(value);
    };

    return (
        <StyledAreaSelect
            autoComplete="off"
            popupClassName="ant-select-dropdown-areaselect"
            value={currentArea}
            onChange={onChangeCurrentArea}
        >
            <Option value="booking" disabled={!accessBooking}>
                <NwIcon
                    primary
                    icon={accessBooking ? byPrefixAndName.fasl['heart-rate'] : byPrefixAndName.fasl['ban']}
                    style={{ marginRight: '.6em' }}
                />
                BOOKING
            </Option>
            <Option value="scouting" disabled={!accessScouting}>
                <NwIcon
                    primary
                    icon={accessScouting ? byPrefixAndName.fasl['globe'] : byPrefixAndName.fasl['ban']}
                    style={{ marginRight: '.6em' }}
                />
                SCOUTING
            </Option>
            <Option value="accounting" disabled={!accessAccounting}>
                <NwIcon
                    primary
                    icon={accessAccounting ? byPrefixAndName.fasl['money-bill-trend-up'] : byPrefixAndName.fasl['ban']}
                    style={{ marginRight: '.6em' }}
                />
                ACCOUNTING
            </Option>
            {!isMobile && (
                <Option value="management" disabled={!accessManagement}>
                    <NwIcon
                        primary
                        icon={accessManagement ? byPrefixAndName.fasl['chart-pie'] : byPrefixAndName.fasl['ban']}
                        style={{ marginRight: '.6em' }}
                    />
                    MANAGEMENT
                </Option>
            )}
            <Option value="art" disabled={!accessArt}>
                <NwIcon
                    primary
                    icon={accessArt ? byPrefixAndName.fasl['camera-retro'] : byPrefixAndName.fasl['ban']}
                    style={{ marginRight: '.6em' }}
                />
                ART & MARKETING
            </Option>
        </StyledAreaSelect>
    );
};

export default AreaSelect;
